export default "__VITE_ASSET__289ab780__"